import type { AccountSubscription } from '@frameio/graphql-client/generated';

export const getIsMountedStorageIncluded = (
  addOns?: AccountSubscription['addOns']
): boolean =>
  addOns?.some((addOn) => addOn.modifier === 'mounted_storage_limit') ?? false;
